import { render, staticRenderFns } from "./CorrectiveDetails.vue?vue&type=template&id=79c4f322"
import script from "./CorrectiveDetails.vue?vue&type=script&lang=js"
export * from "./CorrectiveDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports